import { useAPI, useAsyncHandler } from '~/hooks/common';

import { API_ENDPOINT } from '~/constants';

import type { TypeDeleteExchangeOrdersParams } from '~/types/claim.types';
import type { TypeErrorResponseData } from '~/types/common.types';

/**
 * [교환 신청/조회] 교환 취소 api 요청 훅
 */
const useDeleteExchangeOrders = () => {
  const { runAsync } = useAsyncHandler();

  const deleteExchangeOrders = useAPI<TypeDeleteExchangeOrdersParams>({
    endpoint: API_ENDPOINT.CLAIM.DELETE_EXCHANGE_ORDERS,
    method: 'delete',
  });

  const requestDeleteExchangeOrders = async (
    { exchangeReceiptId }: TypeDeleteExchangeOrdersParams,
    {
      onSuccess,
      onError,
    }: {
      onSuccess?: () => void;
      onError?: (error: TypeErrorResponseData['error']) => void;
    }
  ) => {
    runAsync(() => deleteExchangeOrders({ pathParams: `/${exchangeReceiptId}` }), {
      onSuccess,
      onError: (error: TypeErrorResponseData['error']) => onError?.(error),
    });
  };

  return { requestDeleteExchangeOrders };
};

export default useDeleteExchangeOrders;
